import { type HTMLAttributes, type Key, type ReactNode } from "react";
import { Checkbox } from "@mui/material";

import { Box } from "ui/box/box";
import { SelectOptionContent } from "ui/select/components/select-option-content";
import { OPTION_CHECKBOX_SX, OPTION_SX } from "ui/select/select.styles";

import type { FormatOptionLabelMeta, OptionType } from "ui/select/select.types";

type SelectOptionProps<Option extends OptionType> = {
  /** MUI's props for the row, `key` included — React wants it on the element, not in a spread. */
  optionProps: HTMLAttributes<HTMLLIElement> & { key: Key };
  option: Option;
  selected: boolean;
  multiple: boolean;
  formatOptionLabel?: (option: Option, meta: FormatOptionLabelMeta) => ReactNode;
};

/** A row of the list: a checkbox when `multiple`, then the call site's content or the default one. */
export const SelectOption = <Option extends OptionType>({
  optionProps: { key, ...liProps },
  option,
  selected,
  multiple,
  formatOptionLabel,
}: SelectOptionProps<Option>) => (
  <Box component="li" key={key} {...liProps} sx={OPTION_SX}>
    {multiple && (
      <Checkbox size="small" checked={selected} sx={OPTION_CHECKBOX_SX} disableRipple />
    )}
    {formatOptionLabel ? (
      formatOptionLabel(option, { context: "menu" })
    ) : (
      <SelectOptionContent option={option} />
    )}
  </Box>
);
